import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=d5c68dcc"
import script from "./StudentList.vue?vue&type=script&lang=js"
export * from "./StudentList.vue?vue&type=script&lang=js"
import style0 from "./StudentList.vue?vue&type=style&index=0&id=d5c68dcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports